import React from 'react';
import InteractiveHome from './InteractiveHome';
import { Box, Typography } from '@mui/material';
import NavButton from './NavButton';

export default function ExploreStep({ rooms, onNext }) {
  return (
    <Box>
      <Typography variant="h3" fontWeight={500} mb={0.5}>
        Explore Electrification
      </Typography>
      <Typography variant="body1" mb={5}>
        Switching to electric appliances may lower your energy bills. Hover over appliances below to
        explore upgrade options. Cost and Savings estimates reflect the average PG&E residential
        customer.
      </Typography>

      <Box mb={7}>
        <InteractiveHome rooms={rooms} onClick={() => {}} />
      </Box>

      <NavButton onClick={onNext} variant="primary">
        Get Started
      </NavButton>
    </Box>
  );
}
